import styled from 'styled-components';
import { FlexColumn, Icon } from '..';

const Wrapper = styled(FlexColumn)`
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  padding: ${({ theme }) => theme.padding[7]};
`;

const StyledIcon = styled(Icon)`${({ theme }) => `
  font-size: ${theme.fontSize[11]};
  line-height: ${theme.fontSize[11]};
  color: ${theme.colours.neutral[7]};
  cursor: default;
  margin-bottom: ${theme.padding[2]};
`}`;

const Title = styled.p`${({ theme }) => `
  font-family: 'Open Sans';
  font-size: ${theme.fontSize[2]};
  line-height: ${theme.fontSize[6]};
  color: ${theme.colours.neutral[2]};
  font-weight: ${theme.fontWeight.bold};
  margin-bottom: ${theme.padding[1]};
`}`;

const Message = styled.p`
  font-family: 'Open Sans';
  font-size: ${({ theme }) => theme.fontSize[1]};
  line-height: ${({ theme }) => theme.fontSize[3]};
  color: ${({ theme }) => theme.colours.neutral[3]};
`;

interface EmptyDataProps {
  title?: string;
  message?: string;
  className?: string;
}

export function EmptyData({
  title = 'There are no records to display yet.',
  message = 'Please add a new record.',
  className = 'mi-table',
}: EmptyDataProps) {
  return (
    <Wrapper>
      <StyledIcon className={className} />
      <Title>{title}</Title>
      <Message>{message}</Message>
    </Wrapper>
  );
}

export function EmptySearchData({
  title = 'No records found.',
  message = 'Please check spelling or try different keywords.',
  className = 'mi-search',
}: EmptyDataProps) {
  return (
    <Wrapper>
      <StyledIcon className={className} />
      <Title>{title}</Title>
      <Message>{message}</Message>
    </Wrapper>
  );
}
